<template lang="pug">
div
    div.box
        v-server-table(
            :url="datatableUrl",
            :name="tableName",
            ref="datatable",
            :columns="columns",
            :options="options"
        )

    div.box
        attendance-summary
</template>

<script>
import attendanceSummary from './staff-attendance-summary.vue';

export default {
    components: { attendanceSummary },

    data() {
        return {
            tableName: 'ATTENDANCE_REPORT',
            columns: ['name', 'uuid', 'time_in', 'time_out', 'duration'],
            options: {
                useReportFilter: true,
                texts: {
                    title: 'Staff Attendance Report',
                    description: 'Staff attendance history',
                },
                headings: {
                    uuid: 'Attendance ID',
                },
                skin: 'table m-b-0 b-b',
                templates: {
                    uuid: (h, row) => {
                        if (!row.uuid) return '';
                        return row.uuid.substring(0, 8);
                    },
                    time_in(h, row) {
                        if (_.isNull(row.time_in)) {
                            return '';
                        }

                        return moment(row.time_in).format('DD/MM/YYYY hh:mm a');
                    },
                    time_out(h, row) {
                        if (_.isNull(row.time_out)) {
                            return '';
                        }

                        return moment(row.time_out).format(
                            'DD/MM/YYYY hh:mm a',
                        );
                    },
                },
                responseAdapter(res) {
                    const data = res.data.data;
                    const grouped = _.groupBy(data, 'time_in_date');
                    const results = [];

                    _.forEach(grouped, (rows, dates) => {
                        results.push({
                            name: moment(dates).format('dddd, DD/MM/YYYY'),
                            time_in: null,
                            time_out: null,
                            duration: '',
                            parent: true,
                        });

                        rows.forEach(row => {
                            row.parent = false;
                            results.push(row);
                        });
                    });

                    return {
                        data: results,
                        count: res.data.count,
                    };
                },

                rowClassCallback(row) {
                    if (row.parent) {
                        return 'table-row-divider';
                    }

                    return null;
                },

                orderBy: {
                    column: 'time_in',
                    ascending: false,
                },

                pdf_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance',
                    { type: 'XLSX' },
                ),
            },
        };
    },

    computed: {
        datatableUrl() {
            return Laroute.route(
                'franchise.report.staff_attendance.attendance_list',
            );
        },
    },

    methods: {},
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/staff-attendance/staff-attendance-list.vue